<template>
	<v-container class="space-y-md pb-3xl">
		<div class="mx-sm space-y-sm md:mx-0">
			<v-h3 tag="h1">
				{{ story.content.title }}
			</v-h3>

			<p
				v-if="story.published_at !== null"
				class="text-sm tracking-xl text-gray-500"
			>
				Päivitetty viimeksi {{ formatLocalDate(story.published_at) }}
			</p>
		</div>

		<v-terms-navigation class=""></v-terms-navigation>

		<div
			class="mx-sm prose prose-sm wrap-break-word md:mx-0 lg:prose-lg xl:prose-xl"
		>
			<sb-rich-text :document="story.content.content" />
		</div>
	</v-container>
</template>

<script lang="ts" setup>
import type {ISbStoryData} from "storyblok-js-client";

import {useLocalDate} from "@pkg/shared/composables/use-local-date";

const properties = defineProps<{
	story: ISbStoryData;
}>();

const {format: formatLocalDate} = useLocalDate();

useSeoMeta({
	title: () =>
		properties.story.content.meta?.title ||
		properties.story.content.title ||
		properties.story.name,

	description: () =>
		(properties.story.content.meta?.description ||
			properties.story.content?.short_description) ??
		undefined,
	ogTitle: () => properties.story.content.meta?.title || properties.story.name,

	ogDescription: () =>
		(properties.story.content.meta?.description ||
			properties.story.content?.short_description) ??
		undefined,
	ogImage: () => properties.story.content?.og_image?.filename ?? undefined,
});
</script>
